import { createContext } from "react";
import type { GridSortModel } from "@mui/x-data-grid/models";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import { type FormAction } from "src/components/Form/Form.types.ts";
import { type GlobalModuleTabsStore } from "src/App/GlobalModuleTabsStore.ts";

type OpenListTabParams = {
  resource: string;
  type: "list";
  filterModel?: GridFilterModel;
  sortModel?: GridSortModel;
  page?: number;
  refresh?: boolean;
};

export type OpenFormTabParams = OpenEditFormTabParams | OpenCreateFormTabParams;
type OpenEditFormTabParams = {
  resource: string;
  type: "form";
  action: FormAction.Edit;
  id: string;
  tab?: string;
  refresh?: boolean;
  searchParams?: URLSearchParams;
  subTab?: string;
  subTabId?: string;
};
type OpenCreateFormTabParams = {
  resource: string;
  type: "form";
  action: FormAction.Create;
  refresh?: boolean;
  searchParams?: URLSearchParams;
};

export type OpenTabParams = OpenListTabParams | OpenFormTabParams;

export type OpenListParams = Omit<OpenListTabParams, "type">;

export type GlobalModuleTabsApi = {
  openTab: (params: OpenTabParams) => Promise<void>;
  openList: (params: OpenListParams) => Promise<void>;
  getTabPath: (params: OpenTabParams) => string;
};

export type GlobalModuleTabsContextValue = {
  store: GlobalModuleTabsStore;
  api: GlobalModuleTabsApi;
};

export const GlobalModuleTabsContext =
  createContext<null | GlobalModuleTabsContextValue>(null);
